export default __webpack_public_path__ + "21a8aabdb5955a541ae2c320c334343a.png";